import selectComponent from 'utilities/select-component'
import AjaxForm from './AjaxForm'

export default class RedirectForm extends AjaxForm {
    constructor(element) {
        super(element)

        this.redirectUrl = this.$form.elements.redirect.data('route')
    }

    handleSuccess(data, textStatus, jqXHR) {
        super.handleSuccess(data, textStatus, jqXHR)

        window.location = this.redirectUrl
    }
}
